module.exports = __webpack_public_path__ + "img/button.e8f89a17.png";